export default __webpack_public_path__ + "static/media/black-close.44e7923f.svg";